import type { FC } from "react"
import { Navigate, Outlet, useLocation } from "react-router"

import { resolveAuthContinuePath } from "@/lib/auth-continue-url"
import { useCurrentUser } from "@/lib/useCurrentUser"

export const LoggedOutLayout: FC = () => {
  const currentUser = useCurrentUser()
  const location = useLocation()
  const continueUrl = resolveAuthContinuePath(new URLSearchParams(location.search).get("continue_url"))

  if (currentUser) {
    return <Navigate to={continueUrl} replace state={{ from: location }} />
  }

  return <Outlet />
}
